import React from 'react'
import ProductStore from '../../stores/product-store'
import UpsalePreviewImages from './upsale-preview-images'
import UpsaleGroupPrintsTotal from './upsale-group-prints-total'
import UpsaleGroupPaperTypes from './upsale-group-paper-types'
import UpsaleGroupOptions from './upsale-group-options'
import UpsaleGroupTotal from './upsale-group-total'
import Config from '../../config'
import {Link} from 'react-router-component'
import createReactClass from 'create-react-class'
import PriceFormatter from "../../utils/price-formatter";


var UpsaleGroup = createReactClass({

  getCategoryNameForProduct: function (productId) {
    for (var i = 0; i < Config.ProductCategories.length; i++) {
      for (var j = 0; j < Config.ProductCategories[i].products.length; j++) {
        if (productId == Config.ProductCategories[i].products[j]) {
          var prodCat = Config.ProductCategories[i];
          if (prodCat.getLabelFromProductId) {
            var product = ProductStore.getProductById(prodCat.getLabelFromProductId);
            if (product) {
              return product.getLabel();
            }
          }
          return _(prodCat.label);
        }
      }
    }
  },

  getData: function () {
    var firstItem = this.props.itemList[0],
      product = ProductStore.getProductById(firstItem.getProductId()),
      upsaleOptions = product.getUpsaleOptions(),
      quantity = 0;

    for (var i = 0; i < this.props.itemList.length; i++) {
      quantity += this.props.itemList[i].getQuantity();
    }

    var categoryName = this.getCategoryNameForProduct(firstItem.getProductId());

    return {upsaleOptions: upsaleOptions, quantity: quantity, categoryName: categoryName, productLabel: product.getWidthOptionTitle(firstItem.getProductWidth()), productWidth: firstItem.getProductWidth()};
  },
  render: function() {
    var data = this.getData(),
        upsaleOptions = data.upsaleOptions;

    if (upsaleOptions) {
      return (
        <section className="ope-upsale__group">
          <div className="ope-upsale__content-wrapper row">
            <div className="ope-upsale__group__title">
               <span className="ope-upsale__group__title__category">{_(data.categoryName)}: </span>
               <span className="ope-upsale__group__title__productLabel">{_(data.productLabel)}</span>
               <div className="ope-upsale__group__title__quantity">{_("%s photos", data.quantity)}</div>
            </div>

            <div className="small-12 medium-4 columns ">
              <UpsalePreviewImages itemList={this.props.itemList} />
            </div>

            <div className="small-12 medium-8 columns ">
              <div className="ope-upsale__group__printsheader">
                <span className="ope-upsale__group__printsheader__productCost">{_('Price per print')}</span>
                <span className="ope-upsale__group__printsheader__total">{_('Total')}</span>
              </div>

              <UpsaleGroupPrintsTotal itemList={this.props.itemList} />

              <UpsaleGroupPaperTypes upsaleOptions={upsaleOptions} quantity={data.quantity} productWidth={data.productWidth} itemList={this.props.itemList} productId={this.props.productId} />
              <UpsaleGroupOptions upsaleOptions={upsaleOptions} quantity={data.quantity} productWidth={data.productWidth} itemList={this.props.itemList} productId={this.props.productId} />

            </div>
          </div>
          <UpsaleGroupTotal itemList={this.props.itemList} />
        </section>
      );
    } else {
      return <div></div>;
    }

  }
});

export default UpsaleGroup;
